module.exports = __webpack_public_path__ + "static/img/d2.a192dcd9.png";